define([], function () {
     if (typeof Object.create !== 'function') {
         // Fix for IE8 which does not contain Object.create() method. It is
         // used heavily in widgets.
         Object.create = function (o)  {
             function F() { }
             F.prototype = o;
             return new F();
         };
     }
     return Object;
});


//////////////////
// WEBPACK FOOTER
// ./~/fcse-compatibility/object.js
// module id = 2
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23